<script>
    import * as Tone from "tone";
    import loaderStore from '../Player.svelte'
    import Loader from "./Loader.js"
    import {createEventDispatcher, onMount} from 'svelte';
    import {Sampler} from "tone";
    // Other relevant code...
    import {rem} from "../utils.js"
    import {writable} from "svelte/store";

    const dispatch = createEventDispatcher();

    let sequencer = null;
    export let subdivision = "8n";
    let highlighted = -1;
    let started = false;
    let loader
    let tracks
    // styling
    const buttonWidth = 50;
    const columnWidth = 100;
    const titleWidth = 100;

    let scheduledPatterns = []
    let scheduledClearedRows = []
    let scheduledMutes = [];
    let storedRows = {};

    export let columns = 16;
    let recentColumn = 0;
    export let rows = 1;
    export let matrix = null;
    export let titles = [];
    export let patternmatrix = null;
    export let urls;
    let patternMatrix = null;
    let _matrix = [];
    let newMatrix = []

    let rowMuteStatus = writable(Array(rows).fill(false));

    let titleRowCellRef;
    let notesRowCellRef;

    $: if (titleRowCellRef && notesRowCellRef) {
        let computedStyle = getComputedStyle(notesRowCellRef);
        titleRowCellRef.style.paddingTop = computedStyle.paddingTop;
    }

    onMount(async () => {
        Tone.Transport.on("start", () => started = true);
        Tone.Transport.on("stop", () => {
            highlighted = -1;
            started = false;
        });
        //    const loader = new Loader();
        //  await loader.start()

//        tracks = Array.from(loader.data.tracks);
        //      patternMatrix = Array.from(loader.data.patternMatrix)

        if (matrix === null) {
            _matrix = indexArray(columns).map(() => {
                return indexArray(rows).map(() => false);
            });
        } else {
            _matrix = matrix;
        }
        _matrix.forEach((column, i) => {
            column.forEach((row, j) => {
                if (!newMatrix[j]) {
                    newMatrix[j] = [];
                }
                newMatrix[j][i] = row;
            })
        })
        rowMuteStatus.set(Array(rows).fill(false));
    });

    $: rowMuteStatus.set(Array(rows).fill(false));
    let focused = false;

    const focusHandler = () => {
        focused = true;
    }

    const blurHandler = () => {
        focused = false;
    }

    $: {
        if (columns || subdivision) {
            if (sequencer) {
                sequencer.dispose();
            }
            sequencer = new Tone.Sequence(tick, indexArray(columns), subdivision).start(0);
        }
        if (columns || rows) {
        }
    }

    const loadTracks = (tracks) => {
        return new Tone.Players({
            urls: tracks,
            fadeOut: "64n"
        }).toDestination();
    }


    const indexArray = (count) => {
        const indices = [];
        for (let i = 0; i < count; i++) {
            indices.push(i);
        }
        return indices;
    }

    const tick = (time, index) => {
        Tone.Draw.schedule(() => {
            if (started) {
                highlighted = index;
            }
        }, time);
        if (index === 0 && scheduledMutes.length > 0) {
            // Loop over scheduledMutes array and mute each row
            for (let i = 0; i < scheduledMutes.length; i++) {
                let row = scheduledMutes[i];
                // Store the current state of the row before muting
                storedRows[row] = _matrix.map(column => column[row]);
                for (let col = 0; col < columns; col++) {
                    _matrix[col][row] = false;
                }
            }
            _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)

            // Clear the scheduledMutes array
            scheduledMutes = [];
        }
        if (index === 0 && scheduledClearedRows.length > 0) {
            // Loop over scheduledClearedRows array and clear each row
            for (let i = 0; i < scheduledClearedRows.length; i++) {
                const row = scheduledClearedRows[i];
                for (let col = 0; col < columns; col++) {
                    _matrix[col][row] = false;
                }
            }
            _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)

            // Clear the scheduledClearedRows array
            scheduledClearedRows = [];
        }
        // Apply the scheduled patterns at the start of a new cycle
        if (index === 0 && scheduledPatterns.length > 0) {
            // loop over scheduledPatterns array and change each one
            for (let i = 0; i < scheduledPatterns.length; i++) {
                const scheduledPattern = scheduledPatterns[i];

                for (let col = 0; col < columns; col++) {
                    _matrix[col][scheduledPattern.row] = scheduledPattern.pattern.includes(col);
                }
            }

            _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)

            // Clear the scheduled patterns array
            scheduledPatterns = [];
        }
        _matrix[index].forEach((value, row) => {
            if (value) {
                row = rows - row - 1;

                if (started) {
                    highlighted = index;
                }
//                addTriggerEvent(keys, {time, row})
                dispatch('trigger', {
                    time,
                    row,
                });
            }
        });
        _matrix.forEach((column, i) => {
            column.forEach((row, j) => {
                if (!newMatrix[j]) {
                    newMatrix[j] = [];
                }
                newMatrix[j][i] = row;
            })
        })
    }

    // event handlers and methods
    const updateCell = (column, row) => {
        _matrix[column][row] = !_matrix[column][row];
    }

    const mouseover = (event, column, row) => {
        if (event.buttons) {
            updateCell(column, row);
            /*
            if (Tone.Transport.state !== 'started') {
                // Create a new sampler
                let sampler = new Sampler({
                    urls: {
                        A1: "URL for A1"
                        // ...
                    }
                }).toDestination();

                // Play the sample
                sampler.triggerAttackRelease("A1", 1);

                // Disconnect and dispose of the sampler after it finishes playing.
                // Note that the delay should be at least the duration of the note.
                setTimeout(() => {
                    sampler.disconnect();
                    sampler.dispose();
                }, 1100); // delay in ms
            }

             */
        }
    }

    const clear = (event, row) => {
        if (Tone.Transport.state !== 'started') {
            // If the audio is not running, clear the row immediately
            for (let i = 0; i < _matrix.length; i++) {
                if (_matrix[i].length > row) {
                    _matrix[i][row] = false;
                }
            }
            _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)
        } else {
            // Otherwise, schedule the row for clearance at the start of the next cycle
            scheduledClearedRows.push(row);
        }
    }

    const mute = (event, row) => {
        if (Tone.Transport.state !== 'started') {
        // If the audio is not running, mute the row immediately
        for (let i = 0; i < _matrix.length; i++) {
        if (_matrix[i].length > row) {
        _matrix[i][row] = false;
    }
    }
        _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)
    } else {
        // Otherwise, schedule the row for muting at the start of the next cycle
        scheduledMutes.push(row);
    }

        // Update the rowMuteStatus
        rowMuteStatus.update(status => {
        const newStatus = [...status]; // Make a copy
        newStatus[row] = true;  // Update row status in the copied array
        return newStatus;  // Pass the entire new array to the update method
    });
    }

        const unmute = (row) => {
        // Unmute the row
        for (let col = 0; col < columns; col++) {
        _matrix[col][row] = storedRows[row][col];
    }
        delete storedRows[row];
        _matrix = _matrix; // Trigger Svelte reactive update (As of Svelte 3.9.2)
    }

        const toggleMute = (event, row) => {
        let currentStatus;
        rowMuteStatus.update(status => {
        currentStatus = status[row];
        return status;
    });
        // If the row is currently muted, unmute it
        if (currentStatus) {
        unmute(row);
    } else {
        // Otherwise, mute it
        mute(event, row);
    }
        // Update the rowMuteStatus
        rowMuteStatus.update(status => {
        const newStatus = [...status]; // Make a copy
        newStatus[row] = !currentStatus; // Toggle status in the copied array
        return newStatus; // Pass the entire new array to the update method
    });
    };

    function trigger() {
        dispatch("trigger", {detail: {/* your detail object */}});
    }

    function changePattern(pattern, row) {
// Push the pattern and row into the array
        if (Tone.Transport.state !== 'started') {
            // If the audio is not running, change the pattern immediately
            for (let col = 0; col < columns; col++) {
                _matrix[col][row] = pattern.includes(col);
            }
            _matrix = _matrix; // trigger Svelte reactive update (As of Svelte 3.9.2)
        } else {
            scheduledPatterns.push({
                pattern: pattern.slice(), // make a copy of the pattern
                row: row,
            });
        }
    }

    let sampleTitles = Array.from(titles).reverse()
    const standardwidth = Math.floor(100 / (columns + 2));
    const restspace = 100 - standardwidth * columns;
    const adjustedwidth = 100 / restspace * standardwidth;
</script>
<div id="device"></div>
<div id="stepsequencer">
    <div class="stepsequencer">
        <div class="titles">
            {#each sampleTitles as [key, value]}
                <div class="row">
                <div class="cell" bind:this={titleRowCellRef}>{value}</div>
                </div>
            {/each}
        </div>
        <div class="pattern">
            {#each patternmatrix as group, groupIndex}
                <div class="cell">
                    {#each group as pattern, patternIndex}
                        <button on:click="{() => changePattern(pattern, groupIndex)}">
                        <svg width="{rem(columns*6+columns-1)}" height="10" class="svg">
                            {#each Array(columns).fill() as _, colIndex}
                                {#if pattern.includes(colIndex)}
                                    <rect class="pfilled" x={colIndex*6 + colIndex} y="2" width="6" height="6"/>
                                {:else}
                                    <rect class="pempty" x={colIndex*6 +colIndex} y="2" width="6" height="6"/>
                                {/if}
                            {/each}
                        </svg>
                        </button>
                    {/each}
                </div>
            {/each}
        </div>
        <div class="notes">
            {#each newMatrix as row, y}
                <div class="row">
                    {#each row as cell, x}
                        <div class="cell" style="width:{standardwidth}%;padding-top:{standardwidth}%;"
                             class:highlighted={highlighted === x}>
                            <div class="cell-content">
                                <button on:mouseover={() => mouseover(event, x, y)}
                                        on:mousedown={() => mouseover(event, x, y)}
                                        class:filled={cell}
                                        on:focus={focusHandler}
                                        on:blur={blurHandler}
                                        aria-label={cell ? 'disable' : 'enable'}>
                                <span class="visually-hidden">Button to  {cell ? 'disable' : 'enable'} note {x + 1}
                                    on track {y + 1}</span>
                                </button>
                            </div>
                        </div>
                    {/each}
                    <div class="actions" style="width:{restspace}%;">
                        <div class="cell" style="width:{adjustedwidth}%;padding-top:{adjustedwidth}%;">
                            <div class="cell-content">
                                <button class="clear"
                                        on:click={() => clear(event, y)}>
                                    <span>clear</span><span class="visually-hidden">Clear Pattern {y + 1}</span>
                                </button>
                            </div>
                        </div>
                        <div class="cell" style="width:{adjustedwidth}%;padding-top:{adjustedwidth}%;">
                            <div class="cell-content">
                                <button class="mute" class:muted={$rowMuteStatus[y]}
                                        on:click={() => toggleMute(event, y)}>
                                    <span>mute</span><span class="visually-hidden">Mute Pattern {y + 1}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>

<style lang="scss">
  @use '../theme/_smui-theme.scss';

  #device {
    display:none;
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    background-color: red;
  }

  #stepsequencer {
    display: grid;
    grid-column: col-start / span 12;
    grid-row: 2 / 6;
  }


  /* Tablets (Portrait)*/
  @media only screen and (min-width: 768px) {
    #device {
      background-color: yellow;
    }
  }

  /* Tablets (Landscape) and low resolution desktops */
  @media screen and (min-width: 992px) {
    #device {
      background-color: green;
    }
  }

  /* High resolution desktops */
  @media only screen and (min-width: 1200px) {
    #device {
      background-color: #f90;
    }
  }


  .stepsequencer {
    display: flex;
    flex-wrap: wrap;
    width: 100vw;
    /* If you want space between the cells, uncomment the following line. Adjust the value as needed.*/
    /*justify-content: space-between; */
  }

  /* Adjusting for large screens */
  @media screen and (min-width: 992px) {
    .stepsequencer {
      width: 80%; /* Reduced width on large screens */
      margin: auto; /* Centering on large screens */
    }
  }

  :host {
    width: 100%;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
  }

  .pfilled {
    fill: smui-theme.$button-active-color;
  }

  .pempty {
    fill: smui-theme.$button-color;
  }

  #columns {
    position: absolute;
    z-index: 5;
    display: flex;
    margin-left: smui-theme.rem(121px);

    .column {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: smui-theme.rem(51);
      min-width: smui-theme.rem(51);

      &.highlighted {
        background-color: smui-theme.$tempo-indicator-color;
      }
    }

  }

  .titles {
    display: none;
  }

  .pattern {
    display: none;
  }

  @media screen and (min-width: 992px) {
    .pattern {
      width: smui-theme.rem(120px);
      min-width: smui-theme.rem(120px);
      display: flex;
      flex-direction: column;
      padding-top: smui-theme.rem(5px);

      .cell {
        width: smui-theme.rem(120px);
        min-width: smui-theme.rem(120px);
        flex-direction: column;
        margin-bottom: smui-theme.rem(11);

        .svg {
          padding-top: smui-theme.rem(4);
        }
      }
    }
  }

  .cell-content {
    /* This content will fill the .cell, and can contain your cell's content */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }


  .notes {
    flex-grow: 1;

    .row {
      display: flex;
      flex-direction: row;
      z-index: 10;

      button {
        width: 100%;
        height: 100%;

        &:focus, &:hover {
          background-color: smui-theme.$button-hover-color;
          border: smui-theme.rem(1px) solid smui-theme.$button-border-hover-color;
        }

        &.filled {
          background-color: smui-theme.$button-active-color;
          border: smui-theme.rem(1px) solid smui-theme.$button-active-border-color;

          &:focus, &:hover {
            background-color: smui-theme.$button-active-hover-color;
            border: smui-theme.rem(1px) solid smui-theme.$button-active-border-hover-color;
          }
        }
        &.muted {
          border: smui-theme.rem(1px) solid smui-theme.$button-muted-border-color;
          background-color: smui-theme.$button-muted-color;
        }
      }

      .actions {
        display: flex;

        .cell {
          position: relative;
          margin-left: smui-theme.rem(10px);

          &.highlighted {
            background-color: smui-theme.$tempo-indicator-color;
          }

          .cell-content {
            padding: smui-theme.rem(3px);
          }
        }

        button {
          font-size: .7em;

          &.clear {
            margin-left: smui-theme.rem(10px);
          }
        }
      }

      .cell {
        position: relative;

        &.highlighted {
          background-color: smui-theme.$tempo-indicator-color;
        }

        .cell-content {
          /* This content will fill the .cell, and can contain your cell's content */
          padding: smui-theme.rem(3px);
        }

      }
    }
  }

  @media screen and (min-width: 992px) {
    .notes {
      margin: 10px;

      .row {
        padding-left: smui-theme.rem(20px);

        .actions {
          margin-left: smui-theme.rem(15px);

          button {
            &.clear {
              margin-left: smui-theme.rem(10px);
            }
          }
        }
      }
    }
  }

  button {
    display: block;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border: solid smui-theme.rem(1px) smui-theme.$button-border-color;
    font-size: 1em;
    overflow: hidden;
    background-color: smui-theme.$button-color;
    padding: 0;
    margin: 0;
  }


  button:disabled {
    opacity: 0.5;
    pointer-events: none !important;
    color: #777;
  }

  button::slotted(svg) {
    height: smui-theme.rem(30px);
    display: inline-block;
    transition: fill 0.1s;
  }

  button::slotted(*) {
    pointer-events: none;
  }

  button:hover ::slotted(svg) {
    fill: white;
  }

</style>
